/**
 * Shared styling constants for metric editor components.
 * RHEA: Update these values to change the styling across all metric config fields.
 * Uses semantic color tokens, so each value follows the active theme.
 */

// RHEA: Label styling for all config fields
export const LABEL_STYLES = "text-sm font-medium text-coval-text-muted"

// RHEA: Info icon styling (appears next to labels)
export const INFO_ICON_STYLES = "w-3.5 h-3.5 text-coval-text-muted"

// RHEA: Container for label + info icon row
export const LABEL_ROW_STYLES = "flex items-center gap-1"

// RHEA: Spacing between label and input
export const FIELD_CONTAINER_STYLES = "space-y-2"

// RHEA: Text input styling
export const TEXT_INPUT_STYLES =
  "w-full h-control px-3 text-sm bg-surface-default text-coval-text border border-surface-1 rounded-md focus:outline-none disabled:bg-surface-1 disabled:text-coval-text-muted placeholder:text-coval-text-muted"

// RHEA: Textarea container styling
export const TEXTAREA_CONTAINER_STYLES =
  "bg-surface-default border border-surface-1 rounded-md p-4 overflow-hidden max-h-[600px] overflow-y-auto"

// RHEA: Textarea inner styling
export const TEXTAREA_STYLES =
  "w-full min-h-[300px] text-sm text-coval-text bg-transparent border-none focus:outline-none resize-y placeholder:text-coval-text-muted"
